import { Component, ElementRef, Input, NgZone, ViewChild } from '@angular/core';
import {FormGroup, FormControl, Validators, FormBuilder, NgForm, FormArray, AbstractControl} from '@angular/forms';
import * as $ from 'jquery';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { SuccessDialogComponent } from '../../widgets/successDialog/success-dialog.component';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { AddPieceComponent } from '../add-piece/add-piece.component';
import {UsercourrierService} from "../../services/frapper/usercourrier.service";
import {DossierService} from "../../services/frapper/dossier.service";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {AlertesService} from "../../services/public/alertes.service";
import {CustomService} from "../../services/frapper/custom.service";
import {error} from "@angular/compiler-cli/src/transformers/util";
import {MyCONST} from "../../CONST/myConst";
import {VisualizePieceComponent} from "../visualize-piece/visualize-piece.component";
import { AddAssociationPrevenuComponent } from '../add-association-prevenu/add-association-prevenu.component';
import { DetailsPrevenuComponent } from '../details-prevenu/details-prevenu.component';
import { ViewDetailsDossierComponent } from '../view-details-dossier/view-details-dossier.component';
import { EnrollementService } from '../../services/frapper/enrollement.service';
import { AddInfractionsComponent } from '../add-infractions/add-infractions.component';
import { FormStepperComponent } from '../add-courrier/form-stepper.component';
import {AssignedService} from "../../services/frapper/assigned.service";


@Component({
  selector: 'ngx-add-dossier',
  templateUrl: './add-dossier.component.html',
  styleUrls: ['./add-dossier.component.scss']
})
export class AddDossierComponent {
  @Input() parentModal: BsModalRef;

  isLinear = true;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  data: any;
  step:any;
  modalRef!: BsModalRef;
  is_multiple_prevenu: number ;

  my_tribunal:any = null
  show_second_part = false;
  isInfractionListVisible: boolean[] = [];  // Tableau pour gérer la visibilité du dropdown par ligne
  selectedInfraction: any[] = [];  // Tableau pour stocker les valeurs 'nature' par ligne
  noMatchVisible: boolean[] = [];  // Tableau pour gérer la visibilité de l'option "Ajouter"
  searchTerm: string[] = [];  // Tableau pour stocker les termes de recherche pour chaque ligne
  filteredInfraction: any[] = [];  // Liste filtrée des infractions
  gettedInfractions: any[] = [];

  classifications:any =[];
  natures:any =[];
  identification_type:any =[];
  InternalPieces:any =[]
  prevenusList: any[] = [];
  CAN_SEE_REMARQUE_PROCUREUR:boolean=false
  CAN_NOT_CHANGE_REMARQUE_PROCUREUR:boolean=true
  profil;
  form: FormGroup;
  profil_initial_step=[
    {
      "role": "AGENT DU COURRIER",
      "step_dossier":'Procureur',
      "step_courrier":'Procureur'
    },
    {
      "role": "AGENT DU COURRIER CIVIL",
      "step_dossier":'President du tribunal',
      "step_courrier":'President du tribunal'
    },
    {
      "role": "AGENT DU COURRIER FAMILIAL",
      "step_dossier":'President du tribunal',
      "step_courrier":'President du tribunal'
    },
    {
      "role": "AGENT DU COURRIER SOCIAL",
      "step_dossier":'President du tribunal',
      "step_courrier":'President du tribunal'
    },
    {
      "role": "AGENT DU COURRIER PRESIDENT",
      "step_dossier":'President du tribunal',
      "step_courrier":'President du tribunal'
    },
    {
      "role": "AGENT DU COURRIER GREF",
      "step_dossier":'Greffier',
      "step_courrier":'Greffier'
    },
    {
      "role": "PROCUREUR",
      "step_dossier":'Procureur',
      "step_courrier":'Procureur'
    },
    {
      "role": "SUB PROCUREUR",
      "step_dossier":'Substitut du procureur',
      "step_courrier":'Substitut du procureur'
    },
    {
      "role": "GREFFIER",
      "step_dossier":'Greffier',
      "step_courrier":'Greffier'
    },
    {
      "role": "GREFFIER EN CHEF",
      "step_dossier":'Greffier',
      "step_courrier":'Greffier'
    },
    {
      "role": "JUGE D'INSTRUCTION",
      "step_dossier":'Juge d\'instruction',
      "step_courrier":'Juge d\'instruction'
    },
    {
      "role": "JUGE",
      "step_dossier":'Juge',
      "step_courrier":'Juge'
    },
    {
      "role": "PRESIDENT DU TRIBUNAL",

      "step_dossier":'President du tribunal',
      "step_courrier":'President du tribunal'
    },
    {
      "role": "AGENT ENROLEMENT",
      "step_dossier":'Greffier',
      "step_courrier":'Greffier'
    },
    {
      "role": "AGENT ENROLEMENT PENAL",
      "step_dossier":'Procureur',
      "step_courrier":'Procureur'
    }
  ]

  infractions: any[] =[]
  createCourrierOnFirst: boolean = false;
  showAddCourrier: boolean = true;
  ALL_DESTINATAIRE:any =[]

  constructor(private modalService: BsModalService,
              public options: ModalOptions,
              private formBuilder: FormBuilder,
              private dossierService:DossierService,
              private assigneService:AssignedService,
              private customservice:CustomService,
              private ngxService: NgxUiLoaderService,
              private alerte:AlertesService,
              private zone: NgZone,
              private enrole: EnrollementService,
              public bsModalRef: BsModalRef,
              private fb: FormBuilder,
              private userCourrierService:UsercourrierService,
              private penalService: PenalCourrierService) {
    this.profil = localStorage.getItem('profil');
    this.getInitialStepOfDossier()
    this.data = options.initialState
    this.data.showAddCourrier != null ? this.showAddCourrier =  this.data.showAddCourrier: this.showAddCourrier =true
    console.log('courrier ==> ',this.data)
    try {
      this.InternalPieces = this.data.data.pieces_jointe_au_courrier
    }catch (e) {
      //this.InternalPieces =[]
    }

    this.form = this.fb.group({
      infractions_items: this.fb.array([]),  
    });
    this.step = options.initialState.step;

  }

  closeWithMessage(message: string) {
    this.bsModalRef.hide();
    this.bsModalRef.onHidden.emit(message);
  }
  show_part(){
    this.show_second_part = !this.show_second_part
  }

  removeRow(index: number) {
    this.infractionsItems.removeAt(index);
  }

  get infractionsItems(): FormArray {
    return this.form.get('infractions_items') as FormArray;
  }

  addRow() {
    const newRow = this.fb.group({
      nature: [''],  // Initialement vide
      date: [''],  // Par défaut, on sélectionne "choix du doctype"
      textes: ['']
    });
    this.infractionsItems.push(newRow);

    // Initialiser les valeurs spécifiques pour cette ligne
    this.selectedInfraction.push('');  // Ajout de la valeur 'nature' vide pour cette ligne
    this.isInfractionListVisible.push(false);  // Visibilité de la liste par défaut à false
    this.noMatchVisible.push(false);  // Pas de correspondance au départ
    this.searchTerm.push('');  // Termes de recherche vide par défaut
  }


  openModalAddCourrier(type_courrier: string) {
    const config: ModalOptions = {
      initialState: {
        typeCourrier: type_courrier,
        isSubmitableForm: false,
        parentModal: null // Initialiser parentModal à null
      }
    }
    return new Promise<any>((resolve, reject) => {
      this.modalRef = this.modalService.show(FormStepperComponent, Object.assign({}, config, {class:'modal-lg  modal-newcourrier'}));
      this.modalRef.content.parentModal = this.modalRef;
      this.modalRef.onHidden.subscribe((value: any) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
      });
    }).then(async (value: any) => {
      console.log('this.InternalPieces ==> ', value);
    
      if (value != null) {
        this.data = value
        this.step = 'step3'
        this.createCourrierOnFirst = true
        this.InternalPieces = this.data.values_to_upload
        console.log('this.InternalPieces ==> ', this.InternalPieces);
        
        this.initializeStepper()
      }
       

      console.log('returned object=> ',  value);


    });

  }

  openModalSuccessDialog(message: string) {
    const config: ModalOptions = {
      initialState: {
        message: message
      }
    };
    this.penalService.hiddeModal(this.parentModal);
    this.modalRef = this.modalService.show(SuccessDialogComponent, Object.assign({}, config, {class:'modal-sm'}));
  }

  doAction(){
    if(this.profil == 'PROCUREUR' || this.profil =='SUB PROCUREUR'){
      this.CAN_SEE_REMARQUE_PROCUREUR = true
      if(this.profil == 'PROCUREUR'){
        this.CAN_NOT_CHANGE_REMARQUE_PROCUREUR=false
      }
    }
  }

  openModalAddPiece() {

    const config: ModalOptions = {
      initialState: {
        // message: message
      }
    };
    // this.penalService.hiddeModal(this.parentModal);
    this.modalRef = this.modalService.show(AddPieceComponent, Object.assign({}, config, {class:'modal-lg '}));
  }

  hidde() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }

  selectTypePrevenu(event: any){

    const isChecked = event.target.checked;
    

      if (isChecked) {
        this.is_multiple_prevenu = 1;
      }else{
        this.is_multiple_prevenu = 0;
      }
    
   
    console.log('is_multiple_prevenu==>',this.is_multiple_prevenu);


}

  initializeStepper() {
    console.log('innnnn ssteppp 31  '+this.step );
    var stepFirst = this.step;

    $(document).ready(function(){
      var current_fs, next_fs, previous_fs; //fieldsets
      var opacity;
      var current = 1;
      var steps = $("fieldset").length;


      setProgressBar(current);



      if (stepFirst == 'step3') {
        console.log('in step333 === '+ stepFirst);


        $("fieldset.step1").hide();
        $("fieldset#step1").addClass("active");
        $("fieldset.step2").hide();
        $("#step2").addClass("active");
          // Afficher le fieldset de classe step3
          $("fieldset.step3").show();
        // $("fieldset").eq(2).show();
        current = 4;
        setProgressBar(current++);

        // Ajouter la classe "active" au deuxième élément de la barre de progression
        $("#progressbar li").eq(2).addClass("active");
        console.log("Au moins un élément fieldset a la classe 'cache'");
      }




      // Fonction pour définir la barre de progression
      function setProgressBar(curStep){
          var percent = (100 / steps) * curStep;
          // percent = percent
          $(".progress-bar").css("width",percent+"%");
      }

      // Logique pour passer à l'étape suivante
      $(".next").click(function(){
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          // Ajouter la classe "active" à l'étape suivante de la barre de progression
          $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

          // Afficher le fieldset suivant avec une animation
          next_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  next_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(++current);
      });

      // Logique pour revenir à l'étape précédente
      $(".previous").click(function(){
          current_fs = $(this).parent();
          previous_fs = $(this).parent().prev();

          // Retirer la classe "active" de l'étape actuelle de la barre de progression
          $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

          // Afficher le fieldset précédent avec une animation
          previous_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  previous_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(--current);
      });
  });
  }


  getInitialStepOfDossier(){
    let init_step =''
    let profil_step = this.profil_initial_step.filter(element => element.role?.toUpperCase() == this.profil);
    console.log('profil_step ==> ',profil_step)
    if(profil_step.length > 0){
      init_step = profil_step[0].step_dossier
    }
    console.log('init_step ==> ',init_step)
    return init_step
  }

  onClassificationChange(event: any) {
    let chaine = event.target.value;
    console.log('this.imageFile ==> ',chaine)
    let nature_filter='[["type_de_courrier" , "=","'+chaine+'"]]'
    this.userCourrierService.getAllowedNatureCourrier(nature_filter).then( res =>{
      //console.log(res.data)
      this.natures = res.data
    })
  }

  async createNewCourrierForDossier(body_content){
    try {
      // body_content['workflow_state'] = 'Secrétariat du procureur'
      console.log('For calling api ==> ')

      await this.userCourrierService.nouveauCourrier(body_content).then( res => {
        console.log('Succe create courrier ==> ', res)

        this.data = res.data
        let courrier_name = res.data.name
         for (let val of body_content['values_to_upload']){
           val['parent']=res.data.name
         }
         let toUpDate={}
         toUpDate['pieces_jointe_au_courrier']= body_content['values_to_upload']
         this.customservice.updateTheDoctype(this.userCourrierService.Docatype_courrier_principal,courrier_name, toUpDate).then(res =>{
           //console.log('Succe ==> ',res)
           this.assigneService.doAssignationForRequiredProfil(this.profil,this.userCourrierService.Docatype_courrier_principal,courrier_name)

          this.userCourrierService.updateSatate(courrier_name,'En cours de traitement').then(res => {
            //  this.openModalSuccessDialog('Courrier enregistrer ')
            this.alerte.successNotification('Courrier','Courrier enregistrer!')
              this.ngxService.stop()
             this.closeWithMessage('success');

            //  this.openModalCourrierDetails(res.data)
           },err =>
           {
              this.ngxService.stop()
            //  this.alerte.errorNotification('Une erreur s\'est produite, verifier les données saisies ou vos autorisations')
             console.log('Error ==> ',err)
           })
           //this.openModalSuccessDialog('Piece Ajoutee')
            this.ngxService.stop()
         },error=>{
           console.log('IN ADD DOCTYPE ERR ==> ',error)
            this.ngxService.stop()
           this.alerte.errorNotification('Pieces','Une erreur s\'est produite!')
         })

        //  this.alerte.errorNotification('Une erreur s\'est produite, verifier les données saisies ou vos autorisations')


       return

     },
       error =>{
       console.log('Error ==> ',error)
       this.alerte.errorNotification('Une erreur s\'est produite, verifier les données saisies ou vos autorisations')

          this.ngxService.stopLoader('form_step')
       })
    } catch (error) {
      console.log('erroooorrrrr ',error);

      this.alerte.errorNotification('Une erreur s\'est produite, verifier les données saisies ou vos autorisations')

    }
  }


  async AddNewDossier(dossier: NgForm){
    this.ngxService.start();
    let init_step =''
    // console.log('Form ===> ', dossier.value)
     init_step= this.getInitialStepOfDossier()

    if(dossier.value.reference ==''){
      dossier.value.reference='Non'
    }
    if (this.prevenusList.length == 0) {
     let prevenu = {

        addresse_complete_du_poursuivis: dossier.value['addresse_complete_du_poursuivis'],
        date_de_naissance_du_prévenu: dossier.value['date_de_naissance_du_prévenu'],
        lieu_de_naissance_du_prévenu: dossier.value['lieu_de_naissance_du_prévenu'],
        nom_complet_de_la_mere_du_prévenu: dossier.value['nom_complet_de_la_mere_du_prévenu'],
        nom_complet_du_pere_du_prévenu: dossier.value['nom_complet_du_pere_du_prévenu'],
        nom_complet_du_poursuivis: dossier.value['nom_complet_du_poursuivis'],
        numéro_didentification_du_poursuivis: dossier.value['numéro_didentification_du_poursuivis'],
        type_identification_du_poursuivis: dossier.value['type_identification_du_poursuivis'],
     }
     this.prevenusList.push(prevenu);
    }

    dossier.value["registre"]= 'Courrier Arrivé'

    if(this.data){
      dossier.value["registre"]= this.data.registre
      dossier.value["creation_unite"] = this.data.creation_unite
      dossier.value["position_unite"] = this.data.position_unite
      dossier.value["annotation"] = this.data.annotation
    }
    dossier.value["docstatus"]= 0

    dossier.value["pieces_jointe_au_courrier"]= this.InternalPieces
    console.log('piecesss ===> ', this.InternalPieces)

    let pieces_jointe_au_dossier =[]
    for (let piece of this.InternalPieces){
      let body =  {
          "nom_du_fichier": piece.nom_du_fichier,
          "fichier": piece.fichier,
          "parentfield": "pieces_jointe_au_dossier",
          "parenttype": "Dossier",
          "doctype": "Fichiers joins a un dossier"
        }
      pieces_jointe_au_dossier.push(body)
    }

   this.getValuesFromTableInfraction()


    dossier.value["pieces_jointe_au_dossier"]= pieces_jointe_au_dossier
    dossier.value['is_multiple_prevenu'] = this.is_multiple_prevenu
    dossier.value['association_de_prevenu'] = this.prevenusList
    dossier.value['table_infractions'] = this.infractions

    if(this.my_tribunal !=null){
      dossier.value['tribunal'] = this.my_tribunal.name
    }

    console.log('Form ===> ', dossier.value)

    // si createCourrierOnFirst creer le courrier d'abord
    if (this.createCourrierOnFirst) {
      try {
        await this.createNewCourrierForDossier(this.data);
        // si un nveau courrier est creer ajout de la clee name dans data.
        // this.data.name = this.data.numero_courrier
      } catch (error) {
        console.log('dfffdff', error);

      }

    }



   await  this.dossierService.nouveauDossier(dossier.value).then( async (res:any) => {
      console.log('REsult ---> ', res)
      await this.dossierService.updateSatate(res.data.name,init_step).then(ress => {
          this.assigneService.doAssignationForRequiredProfil(this.profil,this.dossierService.Doctype_dossier,res.data.name)

        // this.openModalSuccessDialog('Dossier enregisté avec success')
        this.alerte.successNotification('Dossier','Dossier enregistré avec succés')
        this.closeWithMessage("success")
        this.openModalDetailsDossier(res.data)
          this.ngxService.stop();
      },
        error =>{
          this.alerte.errorNotification('Mise a jour du dossier','Impossible de mettre a jour le dossier')
          console.log('Error On update==> ',error)
          this.ngxService.stop();
        })

      let update_courrier_infor ={
        "numero_dossier":res.data.name,
        "status_du_dossier":init_step
      }

      console.log('before update courrier',this.data.name,update_courrier_infor);


      await this.userCourrierService.updateCourrier(this.data.name,update_courrier_infor).then(res=>{
        console.log('Success ==> vvvcourier',res)

      },error=>{
        console.log('Error On Update courrier => ',error)
      })
    },
      error =>{
        this.alerte.errorNotification('Creation de dossier','Impossible de creer le dossier')
        console.log('Error ==> ',error)
        this.ngxService.stopLoader('add_dossier');
      })

      this.ngxService.stop();
  }

  openModalDetailsDossier(data: any) {
    // let courrier:any = this.courriers[id];
    // console.log('details === '+ courrier);

    const config: ModalOptions = {
      initialState: {
        data: data,
        type: 'dossier'
      }
     }
    // this.modalRef = this.modalService.show(ViewDetailsDossierComponent, Object.assign({},config,{class:'modal-xl '}));
    return new Promise<string>((resolve, reject) => {
      this.modalRef = this.modalService.show(ViewDetailsDossierComponent, Object.assign({}, config, {class:'modal-xl modal-dossier '}));
      this.modalRef.content.parentModal = this.modalRef;
      this.modalRef.onHidden.subscribe((value: string) => {
        resolve(value); // Résoudre la promesse avec la valeur retournée
      });
    }).then(async (value: string) => {
      if ( value == "success") {
         this.closeWithMessage("")
      }


    });

  }

  closeModal(){
    this.bsModalRef.hide()
  }


  openModalAddPrevenu() {
    const config: ModalOptions = {
      initialState: {
        type: 'dossier',
        parentModal : null
      }
    }

    // Ouvrir le modal
    let modalRef = this.modalService.show(AddAssociationPrevenuComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    modalRef.content.newPrevenuAdded.subscribe((newPrevenu: any) => {
      console.log('Nouveau prévenu ajouté :', newPrevenu);
      this.prevenusList.push(newPrevenu);
      console.log('Nouveau prévenu ajouté==> :', this.prevenusList);
    });
  }

  openModalDetailsPrevenu(prevenu:any) {
    const config: ModalOptions = {
      initialState: {
        url:URL,
        data: prevenu,
        parentModal : null
      }
    }

    // Ouvrir le modal
    let modalRef = this.modalService.show(DetailsPrevenuComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    modalRef.content.newPrevenuAdded.subscribe((newPrevenu: any) => {

      let existingPrevenuIndex = this.prevenusList.find(p => p === prevenu);
      if (existingPrevenuIndex != null) {
        existingPrevenuIndex = newPrevenu;
      }

      console.log('findeddd :', existingPrevenuIndex);
      // this.prevenusList.push(newPrevenu);

    });
  }
  deleteInfraction(element: any){
    this.infractions = this.infractions.filter(item => item != element);
  }
  openModalVisualPiece(data: any) {
    const URL=MyCONST.API_URL+data.fichier
    const config: ModalOptions = {
      initialState: {
        data: URL,
        url:URL,
        parentModal : null
      }
    }

    // Ouvrir le modal
    const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg ' }));

    // Mettre à jour l'option initialState avec le modalRef
  }

  filterValueChange(value,type){
    if(type=='nature'){
     this.infractions[0].nature = value
    }
    if(type=='date'){
      this.infractions[0].date = value
    }
    if(type=='textes'){
      this.infractions[0].textes = value
    }
  }


  getValuesFromTableInfraction() {
    console.log('in methode');

    this.infractions = [];

     const formData = this.infractionsItems.controls.map((row: AbstractControl) => {
          return {
            nature: row.get('nature').value, 
            date: row.get('date').value,  
            textes: row.get('textes').value,  
          };
        });
        this.infractions = formData

}


async loadAllProfiles(index: number): Promise<void> {
  this.ngxService.start();
  console.log('Chargement des profils pour l\'index', index);
  
  try {
    const res = await this.enrole.getAllInfractions();
    this.gettedInfractions = res.data;
    this.filteredInfraction = [...this.gettedInfractions]; // Initialiser la liste filtrée des profils
  } catch (error) {
    console.error('Erreur lors du chargement des profils:', error);
  } finally {
    this.ngxService.stop();
  }

  // Assurer que la liste des infractions est visible pour cette ligne
  this.isInfractionListVisible[index] = true;
}

addItemToApi(itemName,index) {


  const config: ModalOptions = {
    initialState: {
      label: itemName,
      type: 'infraction'
    }
  };

  console.log('openingSuccess');
  return new Promise<string>((resolve, reject) => {
    this.modalRef = this.modalService.show(AddInfractionsComponent, Object.assign({}, config, {class:'modal-lg'}));
    this.modalRef.content.parentModal = this.modalRef;
    this.modalRef.onHidden.subscribe((value: string) => {
      resolve(value); // Résoudre la promesse avec la valeur retournée
    });
  }).then(async (value: string) => {
    console.log('in addinfraction', value);
    this.noMatchVisible[index] = false

    if ( value == "success") {
      this.enrole.getAllInfractions().then(res=>{
        this.gettedInfractions = res.data
        this.filteredInfraction = [...this.gettedInfractions]

      })

    }

})

}

// Gérer le focus sur un champ input pour une ligne spécifique
onFocus(index: number): void {
  this.loadAllProfiles(index);  // Charger les profils quand on entre dans le champ
}

// Gérer le blur pour masquer la liste
onBlur(index: number): void {
  setTimeout(() => {
    this.isInfractionListVisible[index] = false;  // Masquer la liste après un délai
  }, 200);
}

// Gérer l'événement input pour filtrer les éléments
onInput(index: number, event: any): void {
  this.searchTerm[index] = event.target.value.toLowerCase();  // Mettre à jour le terme de recherche pour cette ligne

  // Filtrer les profils en fonction du terme de recherche
  this.filteredInfraction = this.gettedInfractions.filter(profile =>
    profile.name.toLowerCase().includes(this.searchTerm[index])
  );

  // Afficher ou masquer la suggestion "Ajouter"
  this.noMatchVisible[index] = this.filteredInfraction.length === 0 && this.searchTerm[index].trim() !== '';
}

// Sélectionner un profil dans la liste
selectProfile(item: any, index: number): void {
  this.selectedInfraction[index] = item.name;  // Mettre à jour la valeur spécifique de cette ligne

  this.onInput(index, { target: { value: item.name } });  // Met à jour la valeur du champ 'nature'
  this.isInfractionListVisible[index] = false;  // Masquer la liste après sélection
}



  ngOnInit() {

    this.doAction()
    this.is_multiple_prevenu = 0;
    //console.log('This.data -----> ', this.data)
    try {
      this.my_tribunal= JSON.parse(localStorage.getItem('my_tribunal'))
    }catch (e) {
      this.my_tribunal =null
    }
    this.userCourrierService.getAllowedClassification().then( res =>{
      //console.log(res.data)
      this.classifications = res.data
    })
    this.userCourrierService.getAllowedNatureCourrier().then( res =>{
      console.log(res.data)
      this.natures = res.data
    })

    this.customservice.getIdentificationType().then(res=>{
      this.identification_type = res.data

    })


    var self = this;
    $(document).ready(function(){
      console.log('dddddd rrreeaady');

      self.initializeStepper();
      console.log('jjbjjn');
        // Ajouter une nouvelle ligne au tableau
        $('#addRowBtn_inf').on('click', function() {

        });

        // Gérer la suppression d'une ligne
        $('#myTable').on('click', '.delete-row', function() {
          $(this).closest('tr').remove(); // Supprimer la ligne parente (tr) du clic sur l'icône poubelle (delete-row)
        });


    })


  }
}
